<template> 
    <li class="dropdown-submenu"  @mouseenter="enteredhover" @mouseleave="exitedhover">
        <DropdownItem @click="toggleStatus" :closeOnClick="false" :selected="hover">
            {{ title }}
            <div class="float-right"><i class="fas fa-caret-right"></i></div>
        </DropdownItem>
        <ul class="dropdown-menu"  :style="{ 'display': hover ? 'block' : 'none' }">
            <slot></slot>
        </ul>
    </li>
</template>

<script>
import DropdownItem from "./DropdownItem";
export default {
    name: 'InnerDropdown',
    components: {
        DropdownItem
    },
    props: {
        title: {
            type: String, 
            required: true,
            title: "No title"
        }
    },
    watch: {
        hover: function(newVal, oldVal) {
            console.log(`InnerDropdown hover: ${oldVal} -> ${newVal}`)
        }
    },
    methods: {
        enteredhover: function() {
            this.hover = true;
        },
        exitedhover: function() {
            this.hover = false;
        },
        toggleStatus: function() {
            
            this.hover = !this.hover;
        }
    },
    data() {
        return {
            hover: false
        }
    }
}
</script>

<style lang="scss" scoped>
.dropdown-menu {
    min-width: 250px;
    padding: 0;
}


.dropdown-submenu {
    & >.dropdown-menu, & >.dropdown-menu-right {
        top: 0;
        left: 100%;
        margin-top:-1px;
    }

    & >.dropdown-menu-left {
        top: 0;
        // left: 100%;
        left:-10rem; /* 10rem is the min-width of dropdown-menu */
        margin-top:-1px;
    }

    
}
</style>